export default "/images/22c9e65f0d83b94f9dc860b1d24726e1.avif";